// Common favourite functionality
const FAVOURITES_API_ENDPOINT = window.apiUrl + '/api/favourites';

// Helpers: normalize product ID between numeric and Shopify GID formats
function normalizeProductId(id) {
    if (!id) return '';
    const s = String(id);
    // If it's a Shopify GID like gid://shopify/Product/1234567890 -> extract numeric part
    const match = s.match(/gid:\/\/shopify\/Product\/(\d+)/);
    if (match) return match[1];
    // Otherwise return as string (numeric or any string)
    return s;
}

// Local cache helpers for favourite product IDs (stored as normalized strings)
function loadFavouriteIds() {
    try {
        const raw = localStorage.getItem('favourites_ids');
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        const arr = Array.isArray(parsed) ? parsed : [];
        // Ensure normalized + unique
        const norm = Array.from(new Set(arr.map(normalizeProductId)));
        return norm;
    } catch (e) {
        return [];
    }
}

function saveFavouriteIds(ids) {
    try {
        const arr = Array.isArray(ids) ? ids : [];
        const norm = Array.from(new Set(arr.map(normalizeProductId)));
        localStorage.setItem('favourites_ids', JSON.stringify(norm));
    } catch (e) {
        
    }
}

function attachFavoriteListeners() {
    const cachedIds = new Set(loadFavouriteIds().map(String));
    document.querySelectorAll('.favorite-btn').forEach(btn => {
        btn.removeEventListener('click', handleFavoriteClick);
        btn.addEventListener('click', handleFavoriteClick);

        // Set initial favourite state from localStorage cache (no per-item API call)
        const productId = btn.getAttribute('data-product-id') ||
                          btn.closest('.product-item')?.getAttribute('data-product-id');
        const normId = normalizeProductId(productId);
        if (normId && cachedIds.has(normId)) {
            btn.classList.add('favourite-active');
        } else {
            btn.classList.remove('favourite-active');
        }
    });
}


async function handleFavoriteClick(e) {
    e.preventDefault();

    let productId = this.getAttribute('data-product-id');
    
    if (!productId) {
        const productCard = this.closest('.product-item');
        if (productCard) {
            const cardProductId = productCard.getAttribute('data-product-id');
            if (cardProductId) {
                productId = cardProductId;
            } else {
                this.classList.toggle('favourite-active');
                return;
            }
        }
    }
    
    const customerAccessToken = JSON.parse(localStorage.getItem(window.customerAccessTokenKey));
    const accessToken = customerAccessToken ? customerAccessToken.accessToken : null;
    
    if (!accessToken) {
        // User not logged in - show login modal
        const loginModal = new bootstrap.Modal(document.getElementById('confirmLoginModal'));
        loginModal.show();
        return;
    }
    
    // Instant visual feedback - toggle immediately (only if logged in)
    const wasActive = this.classList.contains('favourite-active');
    this.classList.toggle('favourite-active');

    try {
        // トークンは Authorization ヘッダーでも送る。今のバックエンドは body の accessToken を読むので、body からはまだ外さない
        const response = await fetch(FAVOURITES_API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            mode: 'cors',
            body: JSON.stringify({
                accessToken,
                productId
            })
        });

        const result = await response.json();
        
        // Disable button to prevent multiple clicks
        this.disabled = true;
        
        if (result.success) {
            // Update local cache based on API response
            const ids = new Set(loadFavouriteIds().map(String));
            if (result.data.action === 'added') {
                ids.add(normalizeProductId(productId));
            } else {
                ids.delete(normalizeProductId(productId));
            }
            saveFavouriteIds(Array.from(ids));
        } else {
            // Revert visual state if API failed
            this.classList.toggle('favourite-active');
        }
    } catch (error) {
        // Revert visual state if network error
        this.classList.toggle('favourite-active');
    } finally {
        this.disabled = false;
    }
}

window.attachFavoriteListeners = attachFavoriteListeners;

// Auto-init on DOM ready to ensure baseline toggle state across pages
document.addEventListener('DOMContentLoaded', function() {
    try { attachFavoriteListeners(); } catch (_) {}
});
